import type { LandingPageProduct } from './types';

/**
 * The floored minimum across products priced both ways, because the note claims a saving for
 * every plan on screen. Null when no product has both prices or any of them saves nothing.
 */
export function deriveSavingsPercent(products: LandingPageProduct[]): number | null {
  let min: number | null = null;

  for (const product of products) {
    const monthly = product.prices.monthly?.amountCents;
    const annual = product.prices.annual?.amountCents;
    if (!monthly || annual === undefined) continue;

    // Integer cents until the one division, so 10% never floors to 9 on a float.
    const yearly = monthly * 12;
    const pct = Math.floor(((yearly - annual) * 100) / yearly);
    if (pct <= 0) return null;
    min = min === null ? pct : Math.min(min, pct);
  }

  return min;
}
